import React from "react";

const ErrorPage = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center vh-100">
      <h4>Hata 404</h4>
      <p>
      Sayfa bulunamadı.</p>
    </div>
  );
};

export default ErrorPage;
